import { Project } from '../../../common/certificates/models/valueObjects/Project';
import { Report } from '../../../common/certificates/models/valueObjects/Report';

export class ReportCertificate {
  constructor(private readonly id: number, private readonly project: Project | null, private readonly report: Report) {}

  getId() {
    return this.id;
  }

  getProject() {
    return this.project;
  }

  getReport() {
    return this.report;
  }
}
